// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative import
import actions from '../../actions/actions';
import MailingInformation from './MailingInformation';
import mailingInformationActions from '../../actions/mailingInformation';
import billingSetupActions from '../../actions/billingSetup';
import {getFormElementsIds} from '../utils/addressUtil';
import {ADDRESS_TYPE_MAILING, ADDRESS_TYPE_BILLING} from '../../utils/constants';

function mapStateToProps(state) {
    return {
        translations: state.app.translations,
        publicUuid: get(state, 'app.publicUuid', '-1'),
        siteName: state.system.siteName,
        isBillingSetupFlow: get(state, 'billingSetup.isBillingSetupFlow', false),
        billingSetupUserMeta: get(state, 'billingSetup.userMeta', {}),

        mailingMetadata: get(state, 'mailingInformation.mailingMetadata', ''),
        serviceError: get(state, 'mailingInformation.serviceError', ''),

        mailingCountry: get(state, 'mailingInformation.mailingCountry', ''),
        mailingAddressLine1: get(state, 'mailingInformation.mailingAddressLine1', ''),
        mailingAddressLine2: get(state, 'mailingInformation.mailingAddressLine2', ''),
        mailingCity: get(state, 'mailingInformation.mailingCity', ''),
        mailingState: get(state, 'mailingInformation.mailingState', ''),
        mailingPostalCode: get(state, 'mailingInformation.mailingPostalCode', ''),

        mailingCountryError: get(state, 'mailingInformation.mailingCountryError', ''),
        mailingAddressLine1Error: get(state, 'mailingInformation.mailingAddressLine1Error', ''),
        mailingAddressLine2Error: get(state, 'mailingInformation.mailingAddressLine2Error', ''),
        mailingCityError: get(state, 'mailingInformation.mailingCityError', ''),
        mailingStateError: get(state, 'mailingInformation.mailingStateError', ''),
        mailingPostalCodeError: get(state, 'mailingInformation.mailingPostalCodeError', ''),

        billingCountry: get(state, 'mailingInformation.billingCountry', ''),
        billingAddressLine1: get(state, 'mailingInformation.billingAddressLine1', ''),
        billingAddressLine2: get(state, 'mailingInformation.billingAddressLine2', ''),
        billingCity: get(state, 'mailingInformation.billingCity', ''),
        billingState: get(state, 'mailingInformation.billingState', ''),
        billingPostalCode: get(state, 'mailingInformation.billingPostalCode', ''),

        billingCountryError: get(state, 'mailingInformation.billingCountryError', ''),
        billingAddressLine1Error: get(state, 'mailingInformation.billingAddressLine1Error', ''),
        billingAddressLine2Error: get(state, 'mailingInformation.billingAddressLine2Error', ''),
        billingCityError: get(state, 'mailingInformation.billingCityError', ''),
        billingStateError: get(state, 'mailingInformation.billingStateError', ''),
        billingPostalCodeError: get(state, 'mailingInformation.billingPostalCodeError', ''),

        mailingInformation: get(state, 'mailingInformation', {}),
        isSaveModalOpen: get(state, 'app.isSaveModalOpen', false),
        enableContinueButton: get(state, 'mailingInformation.enableContinueButton', false),
        addressChoice: get(state, 'mailingInformation.addressChoice', 'Billing address')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        mailingInformationActions: bindActionCreators(mailingInformationActions, dispatch),
        billingSetupActions: bindActionCreators(billingSetupActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class MailingInformationContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.actions.enableLoadOverLay(true);
        this.props.mailingInformationActions.getMailingMetadata();
    }

    triggerEdapPageViewAction = () => this.props.actions.triggerEdapPageView(this.props.publicUuid, 'Mailing Address');

    triggerEdapEventOnFocus = (event) => {
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: `Focus on ${event.target.name}`,
            highfrequency: 'true'
        }, {});
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        this.props.actions.enableLoadOverLay(true);
        const {
            mailingAddressLine1, mailingAddressLine2, mailingCity, mailingState, mailingCountry, mailingPostalCode,
            billingAddressLine1, billingAddressLine2, billingCity, billingState, billingCountry, billingPostalCode
        } = this.props;

        const addressDetails = {
            mailingAddress: {
                address1: mailingAddressLine1,
                address2: mailingAddressLine2,
                city: mailingCity,
                stateProvince: mailingState,
                country: mailingCountry,
                postalCode: mailingPostalCode
            },
            billingAddress: {
                address1: billingAddressLine1,
                address2: billingAddressLine2,
                city: billingCity,
                stateProvince: billingState,
                country: billingCountry,
                postalCode: billingPostalCode
            }
        };
        if (this.props.isBillingSetupFlow) {
            this.props.billingSetupUserMeta.billingAddress = addressDetails.billingAddress;
            this.props.billingSetupActions.updateBillingSetupMeta(this.props.billingSetupUserMeta, {});
        }

        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        this.props.mailingInformationActions.updateMailingDetails(addressDetails, this.props.isBillingSetupFlow);
        this.toggleButtonStatus();
    }

    setMailingFieldsError = (errorField) => {
        const {mailingCountry, mailingAddressLine1, mailingCity, mailingState, mailingPostalCode} = this.props;

        const fields = getFormElementsIds(ADDRESS_TYPE_MAILING);
        for (const fieldId of fields) {
            if (fieldId === errorField) {
                this.props.mailingInformationActions.setFieldError(fieldId, '', ADDRESS_TYPE_MAILING);
                break;
            }

            if ((fieldId === `${ADDRESS_TYPE_MAILING}_country` && !mailingCountry)
                || (fieldId === `${ADDRESS_TYPE_MAILING}_address1` && !mailingAddressLine1)
                || (fieldId === `${ADDRESS_TYPE_MAILING}_city` && !mailingCity)
                || (fieldId === `${ADDRESS_TYPE_MAILING}_stateProvince` && !mailingState)
                || (fieldId === `${ADDRESS_TYPE_MAILING}_postalCode` && !mailingPostalCode)) {
                this.props.mailingInformationActions.setFieldError(fieldId, 'ipmob.input.field.required', ADDRESS_TYPE_MAILING);
            }
        }
    }

    setBillingFieldsError = (errorField) => {
        const {billingCountry, billingAddressLine1, billingCity, billingState, billingPostalCode} = this.props;

        const fields = getFormElementsIds(ADDRESS_TYPE_BILLING);
        for (const fieldId of fields) {
            if (fieldId === errorField) {
                this.props.mailingInformationActions.setFieldError(fieldId, '', ADDRESS_TYPE_BILLING);
                break;
            }

            if ((fieldId === `${ADDRESS_TYPE_BILLING}_country` && !billingCountry)
                || (fieldId === `${ADDRESS_TYPE_BILLING}_address1` && !billingAddressLine1)
                || (fieldId === `${ADDRESS_TYPE_BILLING}_city` && !billingCity)
                || (fieldId === `${ADDRESS_TYPE_BILLING}_stateProvince` && !billingState)
                || (fieldId === `${ADDRESS_TYPE_BILLING}_postalCode` && !billingPostalCode)) {
                this.props.mailingInformationActions.setFieldError(fieldId, 'ipmob.input.field.required', ADDRESS_TYPE_BILLING);
            }
        }
    }

    setMailingField = (event) => {
        event.preventDefault();
        this.setMailingFieldsError(event.target.id);
        this.props.mailingInformationActions.setAddressField(event.target.id, event.target.value, ADDRESS_TYPE_MAILING);
        this.toggleButtonStatus();
        if (event.target.tagName && event.target.tagName.toLowerCase() === 'select') {
            this.props.actions.triggerEdapEvent('generic.event', {
                eventcategory: `Mailing ${event.target.name} selected`,
                eventaction: `Mailing ${event.target.name} selected`,
                highfrequency: 'true'
            }, {});
        }
    }

    setBillingField = (event) => {
        event.preventDefault();
        this.setBillingFieldsError(event.target.id);
        this.props.mailingInformationActions.setAddressField(event.target.id, event.target.value, ADDRESS_TYPE_BILLING);
        this.toggleButtonStatus();
        if (event.target.tagName && event.target.tagName.toLowerCase() === 'select') {
            this.props.actions.triggerEdapEvent('generic.event', {
                eventcategory: `Billing ${event.target.name} selected`,
                eventaction: `Billing ${event.target.name} selected`,
                highfrequency: 'true'
            }, {});
        }
    }

    toggleButtonStatus = () => this.props.mailingInformationActions.enableContinueButton();

    showOnMailingFieldBlur = (event) => {
        event.preventDefault();
        if (!event.target.value) {
            this.setMailingFieldsError(event.target.id);
            this.props.mailingInformationActions.setFieldError(event.target.id, 'ipmob.input.field.required', ADDRESS_TYPE_MAILING);
        }
    }

    showOnBillingFieldBlur = (event) => {
        event.preventDefault();
        if (!event.target.value) {
            this.setBillingFieldsError(event.target.id);
            this.props.mailingInformationActions.setFieldError(event.target.id, 'ipmob.input.field.required', ADDRESS_TYPE_BILLING);
        }
    }

    handleAlertDismiss = () => this.props.mailingInformationActions.alertError('');

    handleSaveAndFinishOnClick = () => this.props.actions.showSaveAndFinishModal(true);

    prePopulateLocalState = () => this.props.mailingInformationActions.prePopulateLocalState(this.props.publicUuid);

    handleSaveModalClose = () => this.props.actions.showSaveAndFinishModal(false);

    handleChoiceChange = (event) => {
        if (this.props.mailingCountry) {
            this.props.mailingInformationActions.setAddressChoice(event.target.value);
            this.toggleButtonStatus();
        } else {
            this.setMailingFieldsError();
        }
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: (event.target.value === 'Mailing address') ? 'Same as mailing address selected' : 'Different billing address selected',
            eventaction: 'Address preference selected',
            highfrequency: 'true'
        }, {});
    }

    render() {
        return (
            <MailingInformation
                translations={this.props.translations}
                mailingMetadata={this.props.mailingMetadata}
                handleFormSubmit={this.handleFormSubmit}
                siteName={this.props.siteName}

                handleMailingCountryChange={this.setMailingField}
                mailingCountry={this.props.mailingCountry}
                mailingCountryError={this.props.mailingCountryError}
                onMailingCountryBlur={this.showOnMailingFieldBlur}

                handleBillingCountryChange={this.setBillingField}
                billingCountry={this.props.billingCountry}
                billingCountryError={this.props.billingCountryError}
                onBillingCountryBlur={this.showOnBillingFieldBlur}

                handleMailingAddressLine1Change={this.setMailingField}
                mailingAddressLine1={this.props.mailingAddressLine1}
                mailingAddressLine1Error={this.props.mailingAddressLine1Error}
                onMailingAddress1Blur={this.showOnMailingFieldBlur}

                handleBillingAddressLine1Change={this.setBillingField}
                billingAddressLine1={this.props.billingAddressLine1}
                billingAddressLine1Error={this.props.billingAddressLine1Error}
                onBillingAddress1Blur={this.showOnBillingFieldBlur}

                handleMailingAddressLine2Change={this.setMailingField}
                mailingAddressLine2={this.props.mailingAddressLine2}
                onMailingAddress2Blur={this.showOnMailingFieldBlur}

                handleBillingAddressLine2Change={this.setBillingField}
                billingAddressLine2={this.props.billingAddressLine2}
                onBillingAddress2Blur={this.showOnBillingFieldBlur}

                handleMailingCityChange={this.setMailingField}
                mailingCity={this.props.mailingCity}
                mailingCityError={this.props.mailingCityError}
                onMailingCityBlur={this.showOnMailingFieldBlur}

                handleBillingCityChange={this.setBillingField}
                billingCity={this.props.billingCity}
                billingCityError={this.props.billingCityError}
                onBillingCityBlur={this.showOnBillingFieldBlur}

                handleMailingStateChange={this.setMailingField}
                handleMailingSelectStateChange={this.setMailingField}
                mailingState={this.props.mailingState}
                mailingStateError={this.props.mailingStateError}
                onMailingStateBlur={this.showOnMailingFieldBlur}
                onMailingSelectedStateBlur={this.showOnMailingFieldBlur}

                handleBillingStateChange={this.setBillingField}
                handleBillingSelectStateChange={this.setBillingField}
                billingState={this.props.billingState}
                billingStateError={this.props.billingStateError}
                onBillingStateBlur={this.showOnBillingFieldBlur}
                onBillingSelectedStateBlur={this.showOnBillingFieldBlur}

                handleMailingPostalCodeChange={this.setMailingField}
                mailingPostalCode={this.props.mailingPostalCode}
                mailingPostalCodeError={this.props.mailingPostalCodeError}
                onMailingPostalCodeBlur={this.showOnMailingFieldBlur}

                handleBillingPostalCodeChange={this.setBillingField}
                billingPostalCode={this.props.billingPostalCode}
                billingPostalCodeError={this.props.billingPostalCodeError}
                onBillingPostalCodeBlur={this.showOnBillingFieldBlur}

                triggerEdapEventOnFocus={this.triggerEdapEventOnFocus}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                enableButton={this.props.enableContinueButton}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}

                handleSaveAndFinishOnClick={this.handleSaveAndFinishOnClick}
                prePopulateLocalState={this.prePopulateLocalState}
                isSaveModalOpen={this.props.isSaveModalOpen}
                handleSaveModalClose={this.handleSaveModalClose}

                handleChoiceChange={this.handleChoiceChange}
                choice={this.props.addressChoice}
            />);
    }
}

MailingInformationContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    enableContinueButton: PropTypes.bool,
    mailingCountryError: PropTypes.string,
    mailingAddressLine1Error: PropTypes.string,
    mailingCityError: PropTypes.string,
    mailingStateError: PropTypes.string,
    mailingPostalCode: PropTypes.string,
    serviceError: PropTypes.string
};

MailingInformationContainer.defaultProps = {
    enableContinueButton: false,
    mailingCountryError: '',
    mailingAddressLine1Error: '',
    mailingCityError: '',
    mailingStateError: '',
    mailingPostalCodeError: '',
    serviceError: ''
};
